<template>	
  <v-card
      outlined
    >
      <v-card-title
        class = "primary pa-0 body-2"
      >
        <v-icon
          x-small
          color  = "white"
          class  = "mx-1"
          v-text = "'mdi-calendar-clock'"
        ></v-icon>
        <span>
          {{ $ml.get('schedule') }} 
          {{ info_compt && info_compt.name ? ' - ' + info_compt.name : '' }}
        </span>        
      </v-card-title>
      <v-card-text>
        
        <v-row>
          <template
            v-for = "(item_info, idx_info) of info_fields"
          >
            <v-col
              :key  = "idx_info"
            >
              <!-- :cols = "item_sear" -->
              <!-- :cols = "item_search.cols.col" -->
              <v-select
                v-if    = "item_info.type == 'select'"
                dense
                outlined
                hide-details
                :items       = "item_info.list"
                :label       = "$ml.get(item_info.text)"
                v-model      = "info[item_info.key]"
                :item-value  = "item_info.key_list"
                :item-text   = "item_info.text_list"
                :placeholder = "$ml.get(item_info.placeholder)"
                multiple
                chips
                small-chips
                                
              ></v-select>
                <!-- @input     = "get_list()" -->
              <v-menu
                offset-y            
                :return-value.sync      = "picker[item_info.key]"
                v-if                    = "item_info.type == 'time_picker'"
                :ref                    = "item_info.ref"
                v-model                 = "menu_picker[item_info.menu]"
                :close-on-content-click = "false"
                transition              = "scale-transition"
                max-width               = "290px"
                min-width               = "290px"
              >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      outlined
                      dense
                      v-model       = "picker[item_info.key]"
                      :label        = "item_info.text"
                      prepend-inner-icon  = "mdi-clock-time-four-outline"
                      v-bind        = "attrs"
                      v-on          = "on"
                      hide-details
                    ></v-text-field>
                </template>
                  <!-- full-width -->
                <v-time-picker
                  no-title
                  scrollable
                  v-if            = "menu_picker[item_info.menu]"
                  v-model         = "picker[item_info.key]"
                  format          = "24hr"
                  @click:minute   = "save_time(item_info.key, picker[item_info.key], item_info.ref)"
                ></v-time-picker>
            </v-menu>
            <v-btn
              v-if    = "item_info.type == 'btn'"
              :color  = 'item_info.color'
              @click  = "actions(btn_title)"
            >
              {{ btn_title }}
            </v-btn>
            </v-col>
          </template>
            <v-col 
              cols    = "12"
              v-show  = "false"
            >
              <v-toolbar
                dense
                height="25"
              >
                <v-toolbar-title 
                  class="body-2"
                >
                  {{ $ml.get('registered_schedules') }}
                </v-toolbar-title>
              </v-toolbar>
            
              <v-divider></v-divider>

              <v-data-table
                dense
                fixed-body
                fixed-header
                
                class          = "elevation-5"
                :items         = "render_list"
                
                :height        = "layout_height+'px'"
                :loading       = "false"
                :headers       = "header_table"
                item-key       = "id"
                :options.sync        = "options"
                loading-text         = "Loading... Please wait"                
                :server-items-length = "total"                                
                :footer-props        = "{
                  showFirstLastPage   : true,
                  itemsPerPageOptions : [15, 30],
                  showCurrentPage   : true,
                  itemsPerPageText  : ''
                }"
            >
                <!-- rowsPerPageText: [30] -->
              <template v-slot:item.actions="{ item }" >
                <v-btn
                  x-small
                  color  = "primary"
                  @click = "actions('edit', item)" 
                >
                  <!-- @click="(item)" -->
                  <v-icon
                    x-small
                    v-text = "'mdi-pencil'"
                  ></v-icon>
                </v-btn>          
              </template>

             <!--  <template v-slot:top >
                 <v-text-field 
                      v-model    = "search" 
                      label    = "Search" 
                      class    = "mx-4 pt-1" 
                      append-icon  = "mdi-magnify" 
                      hide-details
                      outlined
                      dense               
                    ></v-text-field>
                      
              </template> -->
            </v-data-table>
            </v-col>
        </v-row>
     
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          x-small
          color  = "primary"
          v-text = "$ml.get(btn_action)"
          @click = "actions(btn_action)"
        ></v-btn>
        <v-btn
          x-small
          color  = "error"
          v-text = "$ml.get('close')"
          @click = "actions('close_modal')"
        ></v-btn>
      </v-card-actions>
  </v-card>
  
</template>
<script>
  export default {
    name  : 'schedule',
    props : [
      'info_to_component'
    ],
    data  : () => ({
     
      events: [],
      colors: ['#2196F3', '#3F51B5', '#673AB7', '#00BCD4', '#4CAF50', '#FF9800', '#757575'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      
      info        : {
        interval: ['daily'],
      },
      info_fields : [
        {
          key         : 'interval',
          text        : 'interval',
          placeholder : 'select',
          type        : 'select',
          list        : [
            'daily', 
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday'
          ]
        },
        {
          key         : 'start',
          text        : 'start time',
          menu        : 'picker_start',
          ref         : 'menu_start',
          placeholder : 'time',
          type        : 'time_picker',
        },
        {
          key         : 'end',
          text        : 'end time',
          menu        : 'picker_end',
          ref         : 'menu_end',
          placeholder : 'time',
          type        : 'time_picker',
        },
        /*{
          key         : 'btn_title',
          text        : 'btn_title',
          type        : 'btn',
          action      : 'btn_title',
          color       : 'primary'
        }*/
      ], 
      menu_picker   : {
        start : false, // menu
        end   : false,      
      },
      picker      : {
        start : "00:00", // 
        end   : "23:59",
      },
      layout_height : 300,
      header_table  : [
        {
          text  : 'interval',
          value : 'interval',
        },
        {
          text  : 'start time',
          value : 'start',
        },
        {          
          text  : 'end time',
          value : 'end',
        }

      ],
      options       : { itemsPerPage : 30 }, 
      total         : 0,
      btn_title     : 'save',
      btn_action    : 'save', 
      list          : [],
      info_compt    : {},
      builders      : ["interval", "start", "end"],
      id_notification : 'smart_schedule'
    }), // data

    created(){
      if (this.info_to_component) {
        this.render_info(this.info_to_component);
      }
    }, // created

    watch : {
      
      info_to_component: function(val){
        if (val) {
          console.log("info shcduel : ", val)
          this.render_info(val);
        }
      }, // info_to_component

    }, //  watch

    methods: {

      actions(act, item, opt){
        if (act == 'save') {
            let search = this.info_compt && this.info_compt.deviceId ? this.info_compt.deviceId : null;
            if (this.info && this.picker){
              let info_up = {
                interval : this.info.interval,
                start    : this.picker.start,
                end      : this.picker.end,
              
              };
              console.log(this.info_compt, "********************** schedule up 1")

              if (this.info_compt.alarmId){

                info_up.id       =  this.info_compt.schedule && this.info_compt.schedule.id ? this.info_compt.schedule.id : null ;
                info_up.alarmId  =  this.info_compt.id ? this.info_compt.id : null;
                
                this.update(info_up);
              }else{            
                info_up.timeZone         = this.$timezone;
                this.info_compt.schedule = info_up; 

                this.actions('emit', search);
              }
            }
            

        }
        if (act == 'close_modal') {
          this.$emit('close', false);
        }
        if (act == 'emit') {
          if (item) {
            this.$emit('action_component',{
              act  : 'render_selecteds_schedule',                
              item : this.info_compt,
            });           
          }else{
            console.log("deviceId not found its require for save schedule")
            this.$EventBus.$emit('notifications_modal', {
              type  : 'error',
              message : 'Device Not found',
            })
          }
        }
      }, // actions

      render_info(item){
        this.info_compt = item;
        if (item.schedule){
          if (item.schedule.interval && item.schedule.interval.length > 0){
            if (item.schedule.id) { // Detail_shedule_devic
              if (typeof item.schedule.interval == 'string') {
                this.info.interval = item.schedule.interval.split(",");
              }else{
                this.info.interval = item.schedule.interval;
              }
            }else{

              this.info.interval = item.schedule.interval;
            }
          }
          this.picker.start = item.schedule.start;
          this.picker.end   = item.schedule.end;

        }
      },

      save_time(key, item, ref){
        console.log("TIME *********************" , item, this.$refs[ref], key, ref)
        this.$refs[ref][0].save(this.picker[key])
        this.picker[key] = item;
        // this.$refs[item].save(picker[item_search.key])
      }, // save time

      update(item){
        console.log(item, "********************** schedule up")
        if (item) {
          let ID            = '';
          let option        = 'put';
          let info_up       = this.$Helper.format_req(item, this.builders);
          info_up.timeZone  = this.$timezone;
          if (item.id){
            ID = '/' + item.id;
          }else
          if(item.alarmId){
            option = 'post';
            info_up["Detail_shedule_device_alarmId"] = item.alarmId;
          }else{
            console.warn("schedule no exist id or alarmId")
            this.info_compt.schedule = item;             
            this.actions('emit', this.info_compt);
            
            return 
          }       
          // console.log(info_up.interval)
          if (typeof info_up.interval == 'object') {
            info_up.interval = info_up.interval.join(",");
          }
          // console.log("********************* schedule : update ", info_up, option);
          
          const api = this.$URL + '/api/v1/alarm/schedule' + ID; 
          
          this.$axios[option](api, info_up).then( res => {
            // console.log( "updated **************************** schedule", this.id_notification);
            this.info_compt.schedule = item; 
            this.actions('emit', this.info_compt);

          }).catch( er => {
            console.log( "Error update ", this.id_notification);
          })
           
          
        }
      }, // update
     
    }, // methods

    computed : {
      
      render_list: function(){
        return this.list;
      }, // render list

    }, // computed
  }
</script>